import { gql } from "apollo-angular";

import { PaginationFragment } from "./pagination-fragment";

export const AIRT_SCAN_QUERY = gql`
  ${PaginationFragment}
  query GetAirtScans($filter: SearchFilter = {}, $first: Int = 20, $after: Int = 0, $sort: AirtSort) {
    airtScans(searchFilter: $filter, first: $first, after: $after, sort: $sort) {
      edges {
        node {
          id
          importedAt
          modelVersion
          classification
          destination
          extra
          feed
          malware
          source
          time
          protocol
          numberOfHits
          lastSeen
          firstSeen
          severity
        }
      }
      pageInfo {
        ...PaginationInfo
      }
    }
  }
`;

export const AIRT_SCAN_CLASSIFICATION_PROTOCOL_QUERY = gql`
  query GetAirtScansClassificationProtocol($filter: SearchFilter = {}) {
    airtScans(searchFilter: $filter, first: 999999) {
      edges {
        node {
          classification
          protocol
          severity
        }
      }
    }
  }
`;

export const AIRT_SCAN_COUNT_QUERY = gql`
  ${PaginationFragment}
  query GetAirtScansCount($filter: SearchFilter = {}, $first: Int = 20, $after: Int = 0) {
    airtScans(searchFilter: $filter, first: $first, after: $after) {
      edges {
        node {
          id
          classification
          protocol
          severity
        }
      }
      pageInfo {
        ...PaginationInfo
      }
    }
  }
`;
